<div class="h-100 single-report-page">
    <app-admin-report [columns]="undeliveredPackagesReport" [hasFilters]="true" [apiUrl]="undeliveredPackagesReportAPI"
                      reportTitle="ADMINISTRATION.UNDELIVERED_PACKAGES_DETAILED_REPORT_TITLE" [dataInterceptor]="formatUndeliveredPackagesData">
    </app-admin-report>
</div>